import React from 'react';
import {
  IconButton, ListItemButton, ListItemIcon, ListItemText, Tooltip, useTheme,
} from '@mui/material';
import { CalendarMonth, DateRange } from '@mui/icons-material';
import { useDateContext } from '../../context/DateContext';
import { useTranslation } from 'react-i18next';

const DateToggle = ({ renderTrigger }) => {
  const { useNepaliDate, toggleDateMode } = useDateContext();
  const { t } = useTranslation();
  const theme = useTheme();

  if (renderTrigger) {
    return renderTrigger(toggleDateMode, useNepaliDate);
  }

  return (
    <Tooltip title={t(useNepaliDate ? 'date.switchToEnglish' : 'date.switchToNepali')}>
      <ListItemButton onClick={toggleDateMode} sx={{ borderRadius: theme.shape.borderRadius }}>
        <ListItemIcon sx={{ minWidth: 36, mr: 1, color: 'primary.main' }}>
          {useNepaliDate ? <DateRange fontSize="small" /> : <CalendarMonth fontSize="small" />}
        </ListItemIcon>
        <ListItemText
          primary={t('date.mode')}
          secondary={useNepaliDate ? t('date.nepaliMode') : t('date.englishMode')}
        />
      </ListItemButton>
    </Tooltip>
  );
};

export default DateToggle;
